import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface OAuthConfig {
  issuer: string;
  authorizeUrl: string;
  tokenUrl: string;
  userinfoUrl: string;
  logoutUrl: string;
  clientId: string;
  redirectUri: string;
  scope: string;
}

export const OAUTH_CONFIG = new InjectionToken<OAuthConfig>('OAUTH_CONFIG', {
  providedIn: 'root',
  factory: () => ({ ...environment.oauth }),
});
